import { useQuery } from 'react-query';

import { fetchContentfulData } from '@/src/services/contentful/fetchContentfulData';
import { graphql } from './__generated__';

export const nextBestActionsQuery = graphql(/* contentful-codegen-graphql */ `
  query nextBestActionsQuery(
    $nbaContainerId: String!
    $preview: Boolean
    $actionCode: String
  ) {
    buildNextBestAction(id: $nbaContainerId, preview: $preview) {
      actionCardsCollection(
        preview: $preview
        where: { actionCode: $actionCode }
      ) {
        ...ShowableCardsFragment
      }
    }
  }
`);

interface Props {
  nbaContainerId: string;
  actionCode?: string;
  enabled?: boolean;
  preview?: boolean;
}

export const useContentfulNextBestActionsQuery = ({
  nbaContainerId,
  actionCode,
  enabled,
  preview,
}: Props) =>
  useQuery(
    ['contentfulNextBestActions', nbaContainerId, actionCode, preview],
    () =>
      fetchContentfulData(
        nextBestActionsQuery,
        {
          nbaContainerId,
          actionCode,
        },
        preview,
      ),
    {
      retry: 3,
      cacheTime: 500000,
      enabled: !!nbaContainerId && (enabled ?? true),
    },
  );
